exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table[data-v-35ab8fc4]{font-size:12px;margin-top:5px}table[data-v-35ab8fc4],td[data-v-35ab8fc4],tr[data-v-35ab8fc4]{border-collapse:collapse}td[data-v-35ab8fc4]{padding-left:1px}th[data-v-35ab8fc4]{text-align:left;padding-left:1px;background-color:#d3d3d3}.btn-print[data-v-35ab8fc4]{color:#fff;background-color:#28a745;border-color:#28a745;box-shadow:none;text-decoration:none;display:inline-block;font-weight:400;text-align:center;vertical-align:middle;cursor:pointer;border:1px solid transparent;padding:.375rem .75rem;font-size:1rem;line-height:1;border-radius:.25rem}@media print{@page{size:A4 landscape;margin:5px}.btn-print[data-v-35ab8fc4]{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-35ab8fc4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/school/fee/StudentFeeChallan.vue
// module id = 112
// module chunks = 0